"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.regexp.match");
var _regenerator2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CkContent',
  data: function data() {
    return {
      loadingComponent: null,
      isLoading: false,
      isandroid: false,
      isios: false,
      TargetType: '',
      TargetPk: '',
      AgentType: 'PC',
      Params: '',
      Uuid: '',
      CustomerNumber: '',
      RoleCode: '',
      hasWatermark: 'N',
      watermarkText: '',
      downloadLock: false,
      pageSource: ''
      // stsToken: '',
      // generateTokenFlag: null
    };
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: '',
          spinner: 'cricle_loader',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  created: function created() {
    this.resourceInit();
    this.eventInit();
    this.dataInit();
  },
  mounted: function mounted() {},
  // destroyed() {
  //   clearInterval(this.generateTokenFlag)
  // },
  methods: {
    resourceInit: function resourceInit() {
      var jqueryUrl = "".concat(window.location.origin, "/script/jquery.min.js");
      var new_element = document.createElement('script');
      new_element.setAttribute('type', 'text/javascript');
      new_element.setAttribute('src', jqueryUrl);
      document.body.appendChild(new_element);
      var videoUrl = "".concat(window.location.origin, "/script/video.min.js");
      var new_element_video = document.createElement('script');
      new_element_video.setAttribute('type', 'text/javascript');
      new_element_video.setAttribute('src', videoUrl);
      document.body.appendChild(new_element_video);
    },
    eventInit: function eventInit() {
      this.checkMobile();
      if (this.isandroid) {
        document.addEventListener('message', this.handleMessage);
        window.addEventListener('message', this.handleMessage);
      } else {
        window.addEventListener('message', this.handleMessage);
      }
    },
    dataInit: function () {
      var _dataInit = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _this = this;
        var token;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.TargetType = this.$route.query.targetType || '';
              this.TargetPk = this.$route.query.targetPk || '';
              this.AgentType = this.$route.query.agentType || 'MOBILE';
              this.Params = this.$route.query.params || '';
              this.Uuid = this.$route.query.uuid || '';
              this.CustomerNumber = this.$route.query.customerNumber || '';
              this.RoleCode = this.$route.query.roleCode || '';
              this.hasWatermark = this.$route.query.hasWatermark || 'N';
              this.watermarkText = this.$route.query.watermarkText || '';
              // 通过app打开时会在尾部带上token
              token = this.$route.query.token || '';
              if (token) {
                this.$store.dispatch('user/setToken', token);
              }
              _context.n = 1;
              return this.getPageSource();
            case 1:
              this.$nextTick(function () {
                _this.init();
              });
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function dataInit() {
        return _dataInit.apply(this, arguments);
      }
      return dataInit;
    }(),
    init: function init() {
      var videoList = [];
      // 转化video
      if (document.querySelectorAll) {
        videoList = document.querySelectorAll('oembed[url]');
      } else {
        videoList = document.getElementsByTagName('oembed');
      }
      for (var i = 0, n = videoList.length; i < n; i++) {
        this.loadVideo(videoList[i], i);
      }
      var that = this;
      // 点击下载附件
      $('.ck-content').on('click', '.attachment-title', function (e) {
        e.stopPropagation(); // 取消事件冒泡
        e.preventDefault();
        var fileName = e.currentTarget.innerText;
        var uuid = '';
        for (var j = 0; j < e.currentTarget.children.length; j++) {
          if (e.currentTarget.children[j].className === 'attachment-uu-box') {
            uuid = e.currentTarget.children[j].innerText;
          }
        }
        var isPdf = fileName.toLowerCase().indexOf('.pdf') > -1;
        if ((that.isandroid || that.isios) && !isPdf) {
          // alert('请移步至网页端下载附件')
        } else {
          if (!uuid) {
            alert('当前附件无法下载，请联系管理员');
            return;
          }
          that.downloadFile(uuid, fileName);
        }
      });
      if (this.hasWatermark === 'Y') {
        var settings = {
          watermark_txt: this.watermarkText
        };
        this.watermark(settings);
      }
    },
    getPageSource: function getPageSource() {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        _this2.$api.notice.getPageDetail(_this2.TargetPk).then(function (result) {
          if (result.success) {
            _this2.pageSource = result.data.appMessagePage;
            // this.pageSource = '<div class=\"attachment-box\"><div class=\"attachment-icon\">附件：</div><div class=\"attachment-title\">MyExpense(新报销系统) - User Guide v1.5.pdf<div class=\"attachment-uu-box\">acc1394e-76bc-4d11-aa64-14895adff242</div></div></div><div class=\"attachment-box\"><div class=\"attachment-icon\"><span style=\"color:hsl(30, 75%, 60%);\">查看：</span></div><div class=\"attachment-title\"><span style=\"color:hsl(30, 75%, 60%);\">MyExpense(新报销系统) - User Guide v1.5.pdf</span><div class=\"attachment-uu-box\"><span style=\"color:hsl(30, 75%, 60%);\">2bfb0fa3-0d23-4c1c-9c6d-080910ab295e</span></div></div></div>'

            // let tmpContent = result.data.content
            // this.stsToken = result.data.stsToken
            // tmpContent = tmpContent.replace(/\$_stsToken/g, this.stsToken)
            // this.pageSource = tmpContent
            // this.getStsTokenJob()
            resolve('success');
          }
        });
      });
    },
    // getStsTokenJob() {
    //   this.generateTokenFlag = setInterval(() => {
    //     this.$api.message.generateToken()
    //       .then(res => {
    //         if (res.success) {
    //           this.stsToken = res.data.stsToken
    //           const reg = new RegExp(/sig[^"]*"/, 'g')
    //           this.pageSource = this.pageSource.replace(reg, this.stsToken + '"')
    //         }
    //       })
    //   }, 8 * 60 * 1000)
    // },
    checkMobile: function checkMobile() {
      var u = navigator.userAgent;
      this.isandroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; // 如果输出结果是true就判定是android终端或者uc浏览器
      this.isios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // 根据输出结果true或者false来判断ios终端
    },
    loadVideo: function loadVideo(element, index) {
      var parent = element.parentNode;
      var url = element.getAttribute('url');
      var videoBox = document.createElement('div');
      var video = document.createElement('video');
      var source = document.createElement('source');
      videoBox.className = 'video-box';
      video.className = 'video video-js vjs-big-play-centered';
      video.setAttribute('id', 'my-player' + index);
      video.setAttribute('controls', 'controls');
      video.setAttribute('preload', 'auto');
      video.setAttribute('lang', 'zh');
      video.setAttribute('playsinline', true); // 禁止在iPhone safari中自动全屏,IOS10及以后
      video.setAttribute('webkit-playsinline', true); // 禁止在iPhone safari中自动全屏
      video.setAttribute('x5-video-player-type', 'h5'); // 禁止在iPhone safari中自动全屏
      video.setAttribute('x5-video-player-fullscreen', true); // 禁止在iPhone safari中自动全屏
      source.setAttribute('src', url);
      video.appendChild(source);
      videoBox.appendChild(video);
      parent.appendChild(videoBox);
      this.initVideo('my-player' + index);
    },
    initVideo: function initVideo(id) {
      var options = {
        languages: {
          zh: {
            Play: '播放',
            Pause: '暂停',
            Mute: '音量',
            'Picture-in-Picture': '画中画',
            Fullscreen: '全屏'
          }
        }
      };
      videojs(id, options, function onPlayerReady() {
        videojs.log('Your player is ready!');

        // In this context, `this` is the player that was created by Video.js.
        // this.play();

        // How about an event listener?
        this.on('ended', function () {
          videojs.log('Awww...over so soon?!');
        });
      });
    },
    downloadFile: function downloadFile(uuid, fileName) {
      var _this3 = this;
      if (this.downloadLock) return;
      this.downloadLock = true;
      this.$api.common.downloadFile(uuid).then(function (result) {
        if (result.success) {
          var tmpSrc = result.data + '&token=' + _this3.$store.getters.sasToken;
          var tmpData = {
            title: fileName,
            src: tmpSrc
          };
          var isPdf = tmpSrc.indexOf('.pdf') > -1;
          if (isPdf) {
            _this3.reviewPdf(tmpData, fileName);
          } else {
            window.open(result.data, 'about:blank');
            if (_this3.TargetType) {
              // 埋点
              // const tmp = {
              //   eventName: 'download',
              //   targetType: this.TargetType,
              //   targetPk: this.TargetPk,
              //   agentType: this.AgentType,
              //   params: `${this.Params}-${fileName}`,
              //   uuid: this.Uuid,
              //   customerNumber: this.CustomerNumber,
              //   roleCode: this.RoleCode
              // }
              // this.dataTracking(tmp)
            }
          }
        } else {
          alert('下载失败，请重试！');
        }
        _this3.downloadLock = false;
      }).catch(function () {
        alert('下载失败，请重试！');
        _this3.downloadLock = false;
      });
    },
    reviewPdf: function reviewPdf(val, fileName) {
      var data = {
        type: 'pdf',
        data: {
          title: fileName,
          url: val.src
        }
      };
      if (this.isandroid || this.isios) {
        try {
          Toaster.postMessage(JSON.stringify(data));
        } catch (err) {
          console.log(err);
        }
      } else {
        if (this.TargetType) {
          // 埋点
          // const tmp = {
          //   eventName: 'view_pdf',
          //   targetType: this.TargetType,
          //   targetPk: this.TargetPk,
          //   agentType: this.AgentType,
          //   params: `${this.Params}-${fileName}`,
          //   uuid: this.Uuid,
          //   customerNumber: this.CustomerNumber,
          //   roleCode: this.RoleCode
          // }
          // this.dataTracking(tmp)
        }
        var pdfUrl = "".concat(window.location.origin, "/pdf/web/").concat(val.permission ? 'view' : 'viewer', ".html?file=") + encodeURIComponent("".concat(val.src, "&pdftitle=").concat(val.title));
        window.open(pdfUrl, 'about:blank');
      }
    },
    // dataTracking(tmp) {
    //   this.$api.login.dataTracking(tmp)
    //     .then(() => {})
    //     .catch(() => {})
    // },
    watermark: function watermark() {
      var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // 默认设置
      var defaultSettings = {};
      if (this.isandroid || this.isios) {
        defaultSettings = {
          watermark_txt: 'text',
          watermark_x: 0,
          // 水印起始位置x轴坐标
          watermark_y: 20,
          // 水印起始位置Y轴坐标
          watermark_rows: 9999999,
          // 水印行数 默认值设置较大值以触发自动计算高度
          watermark_cols: 20,
          // 水印列数
          watermark_x_space: 0,
          // 水印x轴间隔
          watermark_y_space: 50,
          // 水印y轴间隔
          watermark_color: '#000000',
          // 水印字体颜色
          watermark_alpha: 0.3,
          // 水印透明度
          watermark_fontsize: '16px',
          // 水印字体大小
          watermark_font: '微软雅黑',
          // 水印字体
          watermark_width: 180,
          // 水印宽度
          watermark_height: 80,
          // 水印长度
          watermark_angle: 15 // 水印倾斜度数
        };
      } else {
        defaultSettings = {
          watermark_txt: 'text',
          watermark_x: 20,
          // 水印起始位置x轴坐标
          watermark_y: 20,
          // 水印起始位置Y轴坐标
          watermark_rows: 9999999,
          // 水印行数 默认值设置较大值以触发自动计算高度
          watermark_cols: 20,
          // 水印列数
          watermark_x_space: 100,
          // 水印x轴间隔
          watermark_y_space: 80,
          // 水印y轴间隔
          watermark_color: '#000000',
          // 水印字体颜色
          watermark_alpha: 0.3,
          // 水印透明度
          watermark_fontsize: '18px',
          // 水印字体大小
          watermark_font: '微软雅黑',
          // 水印字体
          watermark_width: 200,
          // 水印宽度
          watermark_height: 30,
          // 水印长度
          watermark_angle: 15 // 水印倾斜度数
        };
      }
      // 采用配置项替换默认值，作用类似jquery.extend
      defaultSettings = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, defaultSettings), settings);
      var oTemp = document.createDocumentFragment();

      // 获取页面最大宽度
      var page_width = Math.max(document.body.querySelector('.ck-content').scrollWidth, document.body.querySelector('.ck-content').clientWidth);
      // 获取页面最大长度
      var page_height = Math.max(document.body.querySelector('.ck-content').scrollHeight, document.body.querySelector('.ck-content').clientHeight);

      // 如果将水印列数设置为0，或水印列数设置过大，超过页面最大宽度，则重新计算水印列数和水印x轴间隔
      if (defaultSettings.watermark_cols === 0 || parseInt(defaultSettings.watermark_x + defaultSettings.watermark_width * defaultSettings.watermark_cols + defaultSettings.watermark_x_space * (defaultSettings.watermark_cols - 1)) > page_width) {
        defaultSettings.watermark_cols = parseInt((page_width - defaultSettings.watermark_x + defaultSettings.watermark_x_space) / (defaultSettings.watermark_width + defaultSettings.watermark_x_space));
        defaultSettings.watermark_x_space = parseInt((page_width - defaultSettings.watermark_x - defaultSettings.watermark_width * defaultSettings.watermark_cols) / (defaultSettings.watermark_cols - 1));
      }
      // 如果将水印行数设置为0，或水印行数设置过大，超过页面最大长度，则重新计算水印行数和水印y轴间隔
      if (defaultSettings.watermark_rows === 0 || parseInt(defaultSettings.watermark_y + defaultSettings.watermark_height * defaultSettings.watermark_rows + defaultSettings.watermark_y_space * (defaultSettings.watermark_rows - 1)) > page_height) {
        defaultSettings.watermark_rows = parseInt((defaultSettings.watermark_y_space + page_height - defaultSettings.watermark_y) / (defaultSettings.watermark_height + defaultSettings.watermark_y_space));
        defaultSettings.watermark_y_space = parseInt((page_height - defaultSettings.watermark_y - defaultSettings.watermark_height * defaultSettings.watermark_rows) / (defaultSettings.watermark_rows - 1));
      }
      var x;
      var y;
      for (var i = 0; i < defaultSettings.watermark_rows; i++) {
        y = defaultSettings.watermark_y + (defaultSettings.watermark_y_space + defaultSettings.watermark_height) * i;
        for (var j = 0; j < defaultSettings.watermark_cols; j++) {
          x = defaultSettings.watermark_x + (defaultSettings.watermark_width + defaultSettings.watermark_x_space) * j;
          var mask_div = document.createElement('div');
          mask_div.id = 'mask_div' + i + j;
          mask_div.className = 'mask_div';
          mask_div.appendChild(document.createTextNode(defaultSettings.watermark_txt));
          // 设置水印div倾斜显示
          mask_div.style.webkitTransform = 'rotate(-' + defaultSettings.watermark_angle + 'deg)';
          mask_div.style.MozTransform = 'rotate(-' + defaultSettings.watermark_angle + 'deg)';
          mask_div.style.msTransform = 'rotate(-' + defaultSettings.watermark_angle + 'deg)';
          mask_div.style.OTransform = 'rotate(-' + defaultSettings.watermark_angle + 'deg)';
          mask_div.style.transform = 'rotate(-' + defaultSettings.watermark_angle + 'deg)';
          mask_div.style.visibility = '';
          mask_div.style.position = 'absolute';
          mask_div.style.left = x + 'px';
          mask_div.style.top = y + 'px';
          mask_div.style.overflow = 'hidden';
          mask_div.style.zIndex = '9999';
          // mask_div.style.border="solid #eee 1px";
          mask_div.style.opacity = defaultSettings.watermark_alpha;
          mask_div.style.fontSize = defaultSettings.watermark_fontsize;
          mask_div.style.fontFamily = defaultSettings.watermark_font;
          mask_div.style.color = defaultSettings.watermark_color;
          mask_div.style.textAlign = 'center';
          mask_div.style.width = defaultSettings.watermark_width + 'px';
          mask_div.style.height = defaultSettings.watermark_height + 'px';
          mask_div.style.display = 'block';
          oTemp.appendChild(mask_div);
        }
      }
      document.body.querySelector('.ck-content').appendChild(oTemp);
    },
    handleMessage: function handleMessage(e) {
      try {
        var res = JSON.parse(e.data);
        if (res.type === 'watermark') {
          var settings = res.params || {};
          this.watermark(settings);
        }
      } catch (error) {
        console.log('message error', error);
      }
    }
  }
};